import React from "react"
import drop_down from './../images/icons/drop-down.png'

export default class Dropdown extends React.Component {
  constructor() {
    super();

    this.state = {
      displayMenu: false,
    };

    this.showDropdownMenu = this.showDropdownMenu.bind(this);
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this);

  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.displayMenu !== this.state.displayMenu) {
      this.props.isOpen && this.props.isOpen(this.state.displayMenu);
    }
  }

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ displayMenu: true }, () => {
      document.addEventListener('click', this.hideDropdownMenu);
    });
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
      document.removeEventListener('click', this.hideDropdownMenu);
    });
  }

  render() {
    const { selectedItem, align, disabled, isOpen, items, onItemClick, className, style, buttonStyle, name, btnClass } = this.props
    return (
      <div className={"dropdown-holder inline-blocked " + className} style={style}
      // onBlur={e => setTimeout(() => setIsOpen(false), 200)}
      // onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <button
          onClick={e => !disabled && this.showDropdownMenu(e)} type="button"
          className={"w-100 bd-none dropdown py-8 px-16 radius-4 iran-sans one-line flexed align-c justify-between " + btnClass}
          style={{ backgroundColor: btnClass ? undefined : 'rgba(255, 255, 255, .7)', ...buttonStyle, height: 45, opacity: disabled ? .7 : 1 }}>
          {name && <span className="font-12">{name}: </span>}
          <span style={{ maxWidth: '80%' }} className={`font-13 one-line iran-sans-medium ${disabled ? 'text-semi-disabled' : 'text-shadow'}`}>{selectedItem?.title}</span>
          <img className="icon-xs mr-8" {...(this.state.displayMenu ? { style: { transform: 'rotate(180deg)' } } : {})} src={drop_down} alt="" />
        </button>
        {this.state.displayMenu && items && <div className={"dropdown-items bg-top-nav overflow-auto absolute z-1 " + `slideIn${align === 'top' ? 'Top' : 'Bottom'}`}
          style={{ ...(align === 'top' ? { bottom: '100%' } : { top: '100%' }), maxHeight: 200, boxShadow: '0px 5px 6px #99999975' }}
        // onFocus={() => setIsOpen(true)}
        // onBlur={() => setIsOpen(false)}
        >
          <ul style={{ listStyle: 'none', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}
            className="m-0 p-0 overflow-hidden">
            {
              items.filter(item => (selectedItem?.id && !item.id) || (item.id && (item.id !== selectedItem?.id))).map((item, index) => (
                <li key={index}>
                  <button onClick={e => {
                    onItemClick(item)
                  }} className="px-8 py-10 w-100 bd-none iran-sans one-line dropdown-button">{item.title}</button>
                </li>
              ))
            }
          </ul>
        </div>}
      </div>
    )
  }
}
